import {Component, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {Settings} from '@orga-app/settings/settings.model';
import {RolleCheckboxWrapper} from '../../veranstaltungen/veranstaltungen.page';
import {Action, select, Store} from '@ngrx/store';
import {UuidService} from '@orga-app/providers/uuid.service';
import {IonInput, LoadingController, ModalController} from '@ionic/angular';
import {DocumentService} from '@orga-app/providers/document.service';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import * as fromAuthModule from '@orga-app/auth/reducer';
import {getUserInfo} from '@orga-app/auth/reducer';
import * as fromDokumentverwaltungPage from './dokument-verwaltung.reducer';
import * as actionsUi from './dokument-verwaltung.actions.ui';
import {
    Dokument,
    DokumentAktivierenRequest,
    DokumentAktualisierenRequest,
    DokumentEntfernenRequest,
    DokumentHinzufuegenRequest,
    DokumentUploadAktualisierenRequest, DokumentVeranstaltungsTypenRequest, DokumentVeranstaltungsTypMultiRequest
} from '../../../../clients/vorlagen';
import {
    GetDokumentAction,
    GetDokumenteAction,
    PostDokumentAktivierenAction,
    PostDokumentAktualisierenAction,
    PostDokumentEntfernenAction,
    PostDokumentHinzufuegenAction,
    PostDokumentUploadAktualisierenAction, PostDokumentVeranstaltungsTypenAktivierenAction, PostDokumentVeranstaltungsTypenDeaktivierenAction, PostDokumentVeranstaltungsTypenEntfernenAction, PostDokumentVeranstaltungsTypenHinzufuegenAction
} from '../../../../client-ngrx/vorlagen';
import {takeWhile} from 'rxjs/operators';
import {ModalDokumentLoeschenPage} from '../modal-dokument-loeschen/modal-dokument-loeschen.page';
import {Benutzer, UploadResponse, UploadService} from '../../../../clients/api';
import {getZugriffBenutzerverwaltung} from '../../../navi/navi.reducer';
import {BenutzerverwaltungBenutzerZugriff} from '../../../../clients/benutzerverwaltung';
import {getTheme} from '@orga-app/settings/reducer';
import {SafeUrl} from '@angular/platform-browser';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {DatenquelleVeranstaltungsTypen} from '../../../modale/veranstaltungstyp-auswahl/veranstaltungstyp-auswahl.model';
import {VeranstaltungstypAuswahlPage} from '../../../modale/veranstaltungstyp-auswahl/veranstaltungstyp-auswahl.page';
import {AktuellesDokumentTypenSetzenAction} from './dokument-verwaltung.actions.ui';

@Component({
    selector: 'app-dokument-verwaltung',
    templateUrl: './dokument-verwaltung.page.html',
    styleUrls: ['./dokument-verwaltung.page.scss'],
})
export class DokumentVerwaltungPage implements OnInit {
    @ViewChild('dokumentFileInput', {static: false}) dokumentFileInput;
    @ViewChild('titelInput', {static: false}) titelInput: IonInput;

    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    // API
    aktuellesDokument: Dokument = null;
    dokumentTitel = '';
    dokumentTitelOriginal = '';
    dokumentGruppierungstext = '';
    dokumentAktiviert = false;
    dokumentOeffentlich = false;
    aktuellesDokumentOriginal: Dokument;
    berechtigungRollen: Array<RolleCheckboxWrapper> = [];
    bearbeitenBerechtigungRollen: Array<RolleCheckboxWrapper> = [];
    dokumentberechtigungRolleEntfernenAktiv: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    dokumentberechtigungRolleEntfernenAktiv$: Observable<boolean>;
    dokumentBearbeitenBerechtigungRolleEntfernenAktiv: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    dokumentBearbeitenBerechtigungRolleEntfernenAktiv$: Observable<boolean>;
    userInfo$: Observable<Benutzer>;
    dokumentListeUi$: Observable<Array<ListInputItem>>;
    dokumentListeUiLaden$: Observable<boolean>;
    dokumentListeUiFehler$: Observable<boolean>;
    dokumentListeUiFehlerObjekt$: Observable<any>;
    dokumentListeUiSelektiert$: Observable<Dokument>;
    dokumentDetail$: Observable<Dokument>;
    dokumentDetailUiLaden$: Observable<boolean>;
    dokumentDetailUiFehler$: Observable<boolean>;
    dokumentGeaendert$: Observable<boolean>;
    dokumentDetailUiFehlerObjekt$: Observable<any>;
    dokumentDetailSubscription: Subscription;
    dokumentListeUiSelektiertSubscription: Subscription;

    veranstaltungsTypen$: Observable<Array<ListInputItem>>;
    veranstaltungsTypenSelected$: Observable<Array<string>>;

    istNeu$: Observable<boolean>;

    aktuellerTab = 'AllgemeinesDokument';
    zugriff$: Observable<BenutzerverwaltungBenutzerZugriff>;
    uiDokumentIdSelektiert: string;
    private alive = true;

    constructor(public modalCtrl: ModalController,
                private store: Store<fromDokumentverwaltungPage.PageState>,
                private storeAuth: Store<fromAuthModule.ModuleState>,
                private uuid: UuidService,
                public loadingCtrl: LoadingController,
                private documentService: DocumentService,
                private uploadService: UploadService,
                private settingsProvider: SettingsProvider) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));

        this.dokumentberechtigungRolleEntfernenAktiv$ = this.dokumentberechtigungRolleEntfernenAktiv.asObservable();
        this.dokumentBearbeitenBerechtigungRolleEntfernenAktiv$ = this.dokumentBearbeitenBerechtigungRolleEntfernenAktiv.asObservable();
    }

    // ionViewDidLoad() {
    ngOnInit() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
        this.dokumentListeUi$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentListeUi));
        this.dokumentListeUiLaden$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentListeUiLaden));
        this.dokumentListeUiFehler$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentListeUiFehler));
        this.dokumentListeUiFehlerObjekt$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentListeUiFehlerObjekt));
        this.dokumentListeUiSelektiert$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentListeUiSelektiert));
        this.dokumentDetail$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentDetail));
        this.dokumentDetailUiLaden$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentDetailUiLaden));
        this.dokumentDetailUiFehler$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentDetailUiFehler));
        this.dokumentDetailUiFehlerObjekt$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentDetailUiFehlerObjekt));
        this.dokumentGeaendert$ = this.store.pipe(select(fromDokumentverwaltungPage.getDokumentGeaendert));

        this.istNeu$ = this.store.pipe(select(fromDokumentverwaltungPage.getIstNeu));

        this.userInfo$ = this.storeAuth.pipe(select(getUserInfo));
        this.zugriff$ = this.store.pipe(select(getZugriffBenutzerverwaltung));

        this.veranstaltungsTypen$ = this.store.pipe(select(fromDokumentverwaltungPage.getVeranstaltungsTypen));
        this.veranstaltungsTypenSelected$ = this.store.pipe(select(fromDokumentverwaltungPage.getVeranstaltungsTypenSelected));

        this.dokumentListeUiSelektiertSubscription = this.dokumentListeUiSelektiert$.subscribe((x) => {
            if (x !== undefined && x !== null) {
                if (this.uiDokumentIdSelektiert !== x.dokument_id) {
                    this.uiDokumentIdSelektiert = x.dokument_id;
                }
            } else {
                this.uiDokumentIdSelektiert = '';
            }
        });

        // TODO Die Subscription hier muss anders gelöst werden. Idee: Das kann vlt. alles über einen Selektor geschehen.
        this.dokumentDetailSubscription = this.dokumentDetail$.subscribe((x: Dokument) => {
            if (x != null) {
                if (x.berechtigung_rolle_liste !== null && x.berechtigung_rolle_liste !== undefined) {
                    this.berechtigungRollen = x.berechtigung_rolle_liste.map((fbRolle) => {
                        return <RolleCheckboxWrapper>{
                            rolle: fbRolle.rolle,
                            titel: fbRolle.rolle.titel,
                            fbTitel: fbRolle.funktionsbereich.titel,
                            selected: false
                        };
                    });
                } else {
                    this.berechtigungRollen = [];
                }

                if (x.bearbeiten_berechtigung_rolle_liste !== null && x.bearbeiten_berechtigung_rolle_liste !== undefined) {
                    this.bearbeitenBerechtigungRollen = x.bearbeiten_berechtigung_rolle_liste.map((fbRolle) => {
                        return <RolleCheckboxWrapper>{
                            rolle: fbRolle.rolle,
                            titel: fbRolle.rolle.titel,
                            selected: false,
                            fbTitel: fbRolle.funktionsbereich.titel
                        };
                    });
                } else {
                    this.bearbeitenBerechtigungRollen = [];
                }

                this.aktuellesDokument = x;
                this.dokumentTitel = x.titel;
                this.dokumentTitelOriginal = x.titel;
                this.dokumentAktiviert = x.ist_aktiviert;
                this.dokumentOeffentlich = x.ist_oeffentlich;
                this.dokumentGruppierungstext = x.gruppierung;
                // TODO: Hab ich (TBR) auskommentiert, weil Fokus immer wieder gesetzt wird, wenn man im Beschreibung Feld was editiert.
                // setTimeout(() => {
                //     if (this.titelInput) {
                //         this.titelInput.setFocus();
                //     }
                // }, 500);
            } else {
                this.aktuellesDokument = null;
                this.dokumentTitel = '';
                this.dokumentTitelOriginal = '';
                this.dokumentAktiviert = false;
                this.dokumentOeffentlich = false;
                this.dokumentGruppierungstext = '';
            }
        });
        this.aktuellerTab = 'AllgemeinesDokument';
        this.dokumenteLaden().then();
    }

    ionViewDidLeave() {
        this.dokumentDetailSubscription.unsubscribe();
        this.dokumentListeUiSelektiertSubscription.unsubscribe();
    }


    // DOKUMENTE
    async dokumenteLaden() {
        this.store.dispatch(new GetDokumenteAction());
    }

    async neuesDokument() {
        this.dokumentTitel = '';
        this.dokumentTitelOriginal = '';
        this.aktuellesDokument = null;
        this.berechtigungRollen = [];
        this.bearbeitenBerechtigungRollen = [];
        this.aktuellerTab = 'AllgemeinesDokument';
        const dokument = <Dokument>{
            berechtigung_rollen_ids: [],
            berechtigung_rollen: [],
            dokument_id: null,
            titel: '',
            beschreibung: '',
            gruppierung: '',
            dokument_upload_id: null,
            dateiname: '',
            ist_aktiviert: false,
            ist_oeffentlich: false,
            entity_type: ''
        };
        await this.store.dispatch(new actionsUi.NeuesDokumentAction(dokument));
        setTimeout(() => {
            if (this.titelInput) {
                this.titelInput.setFocus();
            }
        }, 500);
    }

    dokumentAendernInput($event, dokument: Dokument, propName: string = null, propTyp: string = null) {
        if (propName !== null) {
            if (propTyp === 'date') {
                // DATE
                dokument = Object.assign({}, dokument, {[propName]: this[propName]});
            } else {
                // SELECT
                dokument = Object.assign({}, dokument, {[propName]: $event});
            }
        } else if ($event.currentTarget.localName === 'ion-toggle') {
            // TOGGLE
            dokument = Object.assign({}, dokument, {[$event.currentTarget.id]: $event.detail.checked});
        } else if ($event.target.localName === 'ion-checkbox') {
            // CHECKBOX
            dokument = Object.assign({}, dokument, {[$event.target.id]: $event.detail.checked});
        } else if ($event.target.name !== null && $event.target.name !== '') {
            // INPUT
            dokument = Object.assign({}, dokument, {[$event.target.name]: $event.target.value});
        }

        this.store.dispatch(new actionsUi.AktuellesDokumentAendernAction(dokument));
    }

    dokumentAendern(dokument: Dokument) {
        this.store.dispatch(new actionsUi.AktuellesDokumentAendernAction(dokument));
    }

    async dokumentSpeichern() {
        await this.dokumentenTitelSpeichernOderUmbenennen();
    }

    async dokumentenTitelSpeichernOderUmbenennen() {
        // console.log('aktuelles dokument: ', this.aktuellesDokument);
        // console.log('aktuelles dokument original: ', this.aktuellesDokumentOriginal);
        if (this.aktuellesDokument && (this.aktuellesDokument.dokument_id === null || this.aktuellesDokument.dokument_id === undefined)) {
            // Dokument anlegen
            const uuid = this.uuid.generateUUID();
            const dokumentHinzufuegenRequest = <DokumentHinzufuegenRequest>{
                titel: this.aktuellesDokument.titel,
                aktiviert: false,
                dokument_id: uuid,
                beschreibung: this.aktuellesDokument.beschreibung,
                dateiname: this.aktuellesDokument.dateiname,
                gruppierung: this.aktuellesDokument.gruppierung,
                ist_oeffentlich: this.aktuellesDokument.ist_oeffentlich,
                dokument_upload_id: this.aktuellesDokument.dokument_upload_id,
            };
            // console.log('Hinzufügen', dokumentHinzufuegenRequest);
            // this.neuesDokumentUuid = uuid;
            this.store.dispatch(new PostDokumentHinzufuegenAction(dokumentHinzufuegenRequest));
        } else {
            const actions: Array<Action> = [];

            // Dokument austauschen, nur wenn es auch geändert wurde
            if (this.aktuellesDokument && this.aktuellesDokumentOriginal && this.aktuellesDokumentOriginal.dokument_upload_id !== this.aktuellesDokument.dokument_upload_id) {
                const request = <DokumentUploadAktualisierenRequest>{
                    dokument_id: this.aktuellesDokument.dokument_id,
                    dokument_upload_id: this.aktuellesDokument.dokument_upload_id,
                    dateiname: this.aktuellesDokument.dateiname,
                };

                // console.log('uploadAktualsiieren', request);
                actions.push(new PostDokumentUploadAktualisierenAction(request));
            }

            // Dokument umbennen
            if ((this.aktuellesDokumentOriginal &&
                this.aktuellesDokument) && (
                this.aktuellesDokumentOriginal.titel !== this.aktuellesDokument.titel
                || this.aktuellesDokumentOriginal.beschreibung !== this.aktuellesDokument.beschreibung
                || this.aktuellesDokumentOriginal.ist_oeffentlich !== this.aktuellesDokument.ist_oeffentlich
                || this.aktuellesDokumentOriginal.gruppierung !== this.aktuellesDokument.gruppierung
            )
            ) {
                const request = <DokumentAktualisierenRequest>{
                    dokument_id: this.aktuellesDokument.dokument_id,
                    titel: this.aktuellesDokument.titel,
                    gruppierung: this.aktuellesDokument.gruppierung,
                    beschreibung: this.aktuellesDokument.beschreibung,
                    ist_oeffentlich: this.aktuellesDokument.ist_oeffentlich
                };
                // console.log('Aktualsiieren', request);
                actions.push(new PostDokumentAktualisierenAction(request));
            }
            actions.forEach(action => this.store.dispatch(action));
        }
    }

    async dokumentLaden(item: Dokument) {
        this.aktuellesDokumentOriginal = Object.assign({}, item);
        this.store.dispatch(new actionsUi.AktuellesDokumentSetzenAction(item));
        this.store.dispatch(new GetDokumentAction(item.dokument_id));
        // this.store.dispatch(new GetDokumentBerechtigungAction(item.dokument_id));

    }

    async dokumentEntfernen(item: Dokument) {
        const param = {titel: item.titel};
        const modal = await this.modalCtrl.create({component: ModalDokumentLoeschenPage, componentProps: param});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                const request = <DokumentEntfernenRequest>{
                    dokument_id: item.dokument_id,
                };

                this.store.dispatch(new PostDokumentEntfernenAction(request));
            }
        });

        await modal.present();
    }

    async changeIstAktiviert($event: any, dokument: Dokument) {
        // this.dokumentAendernInput($event, dokument);

        if ($event.target.checked !== dokument.ist_aktiviert) {
            const request = <DokumentAktivierenRequest>{
                dokument_id: this.aktuellesDokument.dokument_id,
                ist_aktiviert: $event.target.checked,
            };
            this.store.dispatch(new PostDokumentAktivierenAction(request));
        }
    }

    async changeIstOeffentlich($event, dokument: Dokument) {
        this.dokumentAendernInput($event, dokument);
    }

    // Dokument-Datei per FileOpenDialog auswählen
    async dokumentDateiAuswahlen() {
        this.dokumentFileInput.nativeElement.click();
    }

    async dokumentEinfuegen() {
        console.log('HIER!!!');
        const fi = this.dokumentFileInput.nativeElement;

        if (fi.files && fi.files[0]) {
            const fileToUpload = fi.files[0];
            const loading = await this.loadingCtrl.create({
                spinner: 'dots',
                message: 'Das Dokument wird hochgeladen ...'
            });

            await loading.present();
            this.uploadService.postUploadForm(fileToUpload, 'vorlagen_~_dokumente').subscribe((result: UploadResponse) => {
                this.dokumentAendern(Object.assign({}, this.aktuellesDokument, {
                    dokument_upload_id: result.upload_id,
                    dateiname: result.file_name
                }));
                loading.dismiss();
            }, error2 => {
            });
        }
    }

    async dokumentOeffnen() {
        if (this.aktuellesDokument != null && this.aktuellesDokument.dokument_id != null) {
            const loading = await this.loadingCtrl.create({
                spinner: 'dots',
                message: 'Dokument wird geladen'
            });
            await loading.present();
            // const url = '/api/query/vorlagen/dokumente/' + this.aktuellesDokument.dokument_id + '/download?' + this.aktuellesDokument.dokument_upload_id;
            const url = '/api/query/vorlagen/dokumente/' + this.aktuellesDokument.dokument_id + '/download';
            this.documentService.getDocument(url).pipe(takeWhile(() => this.alive))
                .subscribe(async document => {
                        if (document != null) {
                            await loading.dismiss();
                            this.documentService.saveFile(document, this.replaceSpecialCharacter(this.aktuellesDokument.titel) + '.pdf');
                        } else {
                            // no content
                            await loading.dismiss();
                        }
                    },
                    async error => {
                        alert(error);
                        await loading.dismiss();
                    }, () => {
                    });
        }
    }

    replaceSpecialCharacter(value: string) {
        return value
            .replace(/:/g, '_')
            .replace(/ /g, '_')
            .replace(/ä/g, 'ae')
            .replace(/Ä/g, 'Ae')
            .replace(/ü/g, 'ue')
            .replace(/Ü/g, 'Ue')
            .replace(/ö/g, 'oe')
            .replace(/Ö/g, 'Oe')
            .replace(/ß/g, 'ss')
            .replace(/\//g, '-')
            .replace(/\\/g, '-')
            ;
    }

    async dokumentAbbrechen() {
        this.dokumentTitel = '';
        this.dokumentTitelOriginal = '';
        this.aktuellesDokument = null;
        this.store.dispatch(new actionsUi.DokumentAbbrechenAction());
    }


    changeVeranstaltungsTypenAktiv($event) {
        if ($event.detail.checked === true) {
            const request = <DokumentVeranstaltungsTypenRequest>{
                dokument_id: this.aktuellesDokument.dokument_id,
            };
            this.store.dispatch(new PostDokumentVeranstaltungsTypenAktivierenAction(request));
        } else if ($event.detail.checked === false) {
            const request = <DokumentVeranstaltungsTypenRequest>{
                dokument_id: this.aktuellesDokument.dokument_id,
            };
            this.store.dispatch(new PostDokumentVeranstaltungsTypenDeaktivierenAction(request));
        }
    }

    typenEntfernen(typen: any, detail: Dokument) {
        const request: DokumentVeranstaltungsTypMultiRequest = {
            dokument_id: detail.dokument_id,
            typ_ids: typen
        };
        this.store.dispatch(new PostDokumentVeranstaltungsTypenEntfernenAction(request));
    }

    async typenHinzufuegen(detail: Dokument) {
        const typenIds: Array<string> = [];
        detail.veranstaltungstyp_liste.forEach(item => typenIds.push(item.veranstaltungstyp_id));
        const params = {
            titel: detail.titel,
            nichtAnzuzeigendeTypenIds: typenIds,
            untertitel: 'Typen-Berechtigung für Dokumente',
            datenquelle: DatenquelleVeranstaltungsTypen.VeranstaltungsTypen,
            enableSingleSelection: false
        };
        // console.log('Params: ', params);
        const modal = await this.modalCtrl.create({component: VeranstaltungstypAuswahlPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                // console.log('REsult: ', result);
                result.data.ausgewaehlteTypen.forEach((x: string) => {
                    const request: DokumentVeranstaltungsTypMultiRequest = {
                        dokument_id: detail.dokument_id,
                        typ_ids: result.data.ausgewaehlteTypen,
                    };
                    this.store.dispatch(new PostDokumentVeranstaltungsTypenHinzufuegenAction(request));
                });
            }
        });

        await modal.present();
    }

    typenGewaehlt($event: any) {
        this.store.dispatch(new AktuellesDokumentTypenSetzenAction($event));
    }

}
